import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useChapterMindmap(data = {}) {
  const { enabled = false, chapterID, configs = {}, courseID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getData() {
    return privateFetch
      .get(`/v1/admin/course/${courseID}/chapter/${chapterID}`, configs)
      .then((res) => res.data);
  }

  return useQuery(['chapter-mindmap', { data }], getData, { enabled });
}

export default useChapterMindmap;
